import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../styleConstants";

const styles = {
  textLink: {
    color: styleConstants.colors.themeBlue,
    textDecoration: "none",
    borderBottom: `1px ${styleConstants.colors.themeBlue} solid`,
    transition: "color 0.25s ease",
    "&:hover": {
      borderColor: styleConstants.colors.themeBlueMedium,
      color: styleConstants.colors.themeBlueMedium
    }
  },
  iconLink: {}
};

const HyperLink = props => (
  <a
    className={props.icon ? props.classes.iconLink : props.classes.textLink}
    href={props.href}
    target={props.target}
  >
    {props.children}
  </a>
);

HyperLink.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  icon: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

HyperLink.defaultProps = {
  target: "_blank",
  icon: false
};

export default withStyles(styles)(HyperLink);
